export const VALID_FOR_OPTIONS = [
  { value: 'ONE_MONTH', label: '1 mês' },
  { value: 'TWO_MONTHS', label: '2 meses' },
  { value: 'THREE_MONTHS', label: '3 meses' },
  { value: 'SIX_MONTHS', label: '6 meses' },
  { value: 'YEAR', label: '1 ano' },
  { value: 'LIFETIME', label: 'Vitalício' },
]

export const ADDITIONAL_RESOURCE_OPTIONS = [
  { value: 'PLEADING_CREATOR', label: 'Criação de Peças' },
  { value: 'WHATSAPP_INTEGRATION', label: 'Whatsapp Turbo' },
  { value: 'ARTIFICIAL_INTELLIGENCE', label: 'Tradução de andamentos com IA' },
]
